import { render, staticRenderFns } from "./addFaqs.vue?vue&type=template&id=8391f796"
import script from "./addFaqs.vue?vue&type=script&lang=js"
export * from "./addFaqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports